// SKELETON DATA ("Unlike real data Dont have URLs to images, so loading state will be shown until replaced with real data")
import { skeletonVinylArrayType } from "./types";

export const skeletonVinyls: skeletonVinylArrayType = [
  {
    id: 1,
    title: "Happier Than Ever",
    artist: "Billie Eilish",
    originalPrice: 50.25,
    salePrice: null,
    rating: 9.4,
    genres: ['Pop', 'Alternative/Indie']
  },
{
    id: 2,
    title: "OK Human",
    artist: "Weezer",
    originalPrice: 29.92,
    salePrice: 22.95,
    rating: 7.5,
    genres: ['Alternative/Indie']
  },
{
    id: 3,
    title: "Grizzly Peak",
    artist: "The Dodos",
    originalPrice: 80.95,
    salePrice: 24.95,
    rating: 2.5,
    genres: ['Alternative/Indie']
  },
{
    id: 4,
    title: "Don’t Go Telling Your Mama",
    artist: "Topaz Jones",
    originalPrice: 41.34,
    salePrice: 32.63,
    rating: 8.5,
    genres: ['Hip-Hop/Rap']
  },
{
    id: 5,
    title: "The House is Burning",
    artist: "Isaiah Rashad",
    originalPrice: 49.73,
    salePrice: 38.15,
    rating: 4.9,
    genres: ['Hip-Hop/Rap']
  },
{
    id: 6,
    title: "One Foot In Front of The Other",
    artist: "Griff",
    originalPrice: 49.95,
    salePrice: 30.95,
    rating: 9.5,
    genres: ['Pop', 'Alternative/Indie']
  },
{
    id: 7,
    title: "Punk",
    artist: "Young Thug",
    originalPrice: 52.95,
    salePrice: 34.95,
    rating: 9.2,
    genres: ['Hip-Hop/Rap']
  },
{
    id: 8,
    title: "Friends That Break Your Heart",
    artist: "James Blake",
    originalPrice: 49.95,
    salePrice: null,
    rating: 9.8,
    genres: ['Alternative/Indie']
  },
{
    id: 9,
    title: "The Off Season",
    artist: "J. Cole",
    originalPrice: 43.65,
    salePrice: null,
    rating: 7,
    genres: ['Hip-Hop/Rap']
  },
{
    id: 10,
    title: "We’re All Alone In This Together",
    artist: "Dave",
    originalPrice: 41.00,
    salePrice: null,
    rating: 10,
    genres: ['Hip-Hop/Rap', 'Afrobeats']
  },

  {
    id: 11,
    title: "Justice",
    artist: "Justin Bieber",
    originalPrice: 54.25,
    salePrice: 43.75,
    rating: 10,
    genres: ['R&B/Soul', 'Pop']

  },
  {
    id: 12,
    title: "Views",
    artist: "Drake",
    originalPrice: 24.92,
    salePrice: 21.30,
    rating: 6.5,
    genres: ['Hip-Hop/Rap', 'R&B/Soul']
  }

];